module.exports = __webpack_public_path__ + "static/media/desktop.12868a86.svg";